import { defineCapability } from './internal';
import { args } from '../common/args';

export const NAVIGATE_TO_CAP = defineCapability({
  name: 'NAVIGATE_TO_CAP' as const,
  args: {
    url: args.string(),
    openInNewTab: args.optional(args.bool()),
    openInNewWindow: args.optional(args.bool()),
  },
});
